import { Tab, AppBar, NavigationTheme } from '@dls/react-core';
import React from 'react';
import { Outlet, useNavigate, useMatch } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import { StyledTabs } from '../../components/styled/styles';

interface TabItem {
  value: string;
  label: string;
  navigate: string;
}

export const SettingsOverview = () => {
  const navigate = useNavigate();
  const match = useMatch(`/${RoutePaths.Settings}/:tab/*`);

  const tabs: TabItem[] = [
    // {
    //   label: 'Configurations',
    //   navigate: RoutePaths.Configurations,
    //   value: 'configurations',
    // },
    // {
    //   label: 'Connections',
    //   navigate: RoutePaths.Connections,
    //   value: 'connections',
    // },
    {
      label: 'Algorithms',
      navigate: RoutePaths.Algorithms,
      value: 'algorithms',
    },
  ];

  return (
    <>
      <NavigationTheme>
        <AppBar position="static" color="secondary">
          {match?.params.tab && (
            <StyledTabs value={match?.params.tab?.toLowerCase()}>
              {tabs.map((t: TabItem) => {
                return (
                  <Tab
                    key={t.navigate}
                    style={{ width: `10rem` }}
                    value={t.value}
                    label={t.label}
                    className="navigation"
                    onClick={() => {
                      navigate(t.navigate);
                    }}
                  />
                );
              })}
            </StyledTabs>
          )}
        </AppBar>
      </NavigationTheme>
      <Outlet />
    </>
  );
};
